import React from 'react';

export default function NotFound() {
  return (
    <div className="center-screen">
      <h1 style={{ fontSize: '72px', margin: 0, lineHeight: 1 }}>404</h1>
      <p className="message-text">Page not found</p>
    </div>
  );
}
